<template>
  <v-card class="m-4" elevation="0">
    <v-card-title>Solicitudes Pendientes de Revisión</v-card-title>
    <v-card-text>
      <div class="text-center">
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          clearable
          label="Escribe para filtrar"
          @keyup="onKeyup"
          @click:clear="clearSearch"
        />
      </div>
      <iel-table :headers="headers">
        <tr v-if="requests.length <= 0">
          <iel-table-cell :cols="10"> No hay registros </iel-table-cell>
        </tr>
        <tr v-for="request in requests" :key="`request-${request.id}`">
          <iel-table-cell>{{ request.channel }}</iel-table-cell>

          <iel-table-cell>{{ request.custumer_code }}</iel-table-cell>

          <iel-table-cell>
            <a
              :href="`${url}/customersfiles/${request.id}/envelope`"
              target="_blank"
              >{{ request.envelope_id }}</a
            >
          </iel-table-cell>

          <iel-table-cell>{{ request.person_type }}</iel-table-cell>

          <iel-table-cell>{{ request.created_at }}</iel-table-cell>

          <iel-table-cell>{{ request.company_name }}</iel-table-cell>

          <iel-table-cell>{{ request.rfc }}</iel-table-cell>

          <iel-table-cell>{{ request.a_estate }}</iel-table-cell>

          <iel-table-cell>
            <v-chip
              v-if="request.customer_status.status == 'Revisión Crédito'"
              class="ma-2"
              color="primary"
              small
            >
              {{ request.customer_status.status }}
            </v-chip>
            <v-chip v-else class="ma-2" small>
              {{ request.customer_status.status }}
            </v-chip>
          </iel-table-cell>

          <iel-table-cell>
            <v-btn small icon type="success" @click="goToDetail(request.id)">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </iel-table-cell>
        </tr>
      </iel-table>
      <div class="text-center my-2">
        <v-pagination v-model="pagination.page" :length="pagination.to" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  import { debounce } from '@/utilities/helpers';
  import IelTable from '@/components/tables/IElTable.vue';
  import IelTableCell from '@/components/tables/IELTableCell.vue';
  import { mapActions, mapGetters, mapMutations } from 'vuex';

  export default {
    name: 'CreditView',
    components: { IelTable, IelTableCell },

    data: () => ({
      url: '',
      search: '',
      headers: [
        { text: 'canal' },
        { text: 'Número cliente' },
        { text: 'Transacción ID' },
        { text: 'Tipo' },
        { text: 'Fecha solicitud' },
        { text: 'Razón social' },
        { text: 'RFC' },
        { text: 'Estado' },
        { text: 'Estatus' },
        { text: 'Acciones' },
      ],
    }),

    computed: {
      ...mapGetters({
        requests: 'customersrequest/allRequests',
        pagination: 'customersrequest/pagination',
      }),
    },

    watch: {
      'pagination.page'(value) {
        this.loadData(value);
      },
    },

    mounted() {
      this.url = this.$filesUrl;
      this.debounceFn = debounce(() => this.loadData(1, this.search), 800);
      this.loadData(1);
    },

    methods: {
      ...mapMutations({
        setPage: 'customersrequest/SET_PAGE',
      }),
      ...mapActions({
        loadCustomerRequest: 'customersrequest/loadCustomerRequest',
      }),
      onKeyup() {
        this.debounceFn();
      },
      loadData(page, search = '') {
        let status = 4;
        this.loadCustomerRequest({ status, search, page });
      },
      goToDetail(customerId) {
        this.$router.push(`/credit/customers-request/${customerId}`);
      },
      clearSearch() {
        this.setPage(1);
        this.loadData(1);
      },
    },
  };
</script>
